"use client";

import type { DrawingInstance } from "@/lib/chart-drawings/types";
import { ENABLED_DRAWING_IDS } from "@/lib/chart-drawings/registry";
import DrawingConfigScreen from "./properties/DrawingConfigScreen";

interface DrawingConfigFactoryProps {
  drawing: DrawingInstance;
  onBack: () => void;
  onSave: (updated: DrawingInstance) => void;
}

export default function DrawingConfigFactory({
  drawing,
  onBack,
  onSave,
}: DrawingConfigFactoryProps) {
  if (!ENABLED_DRAWING_IDS.has(drawing.type)) {
    console.warn(
      `[DrawingConfigFactory] No config for disabled type: ${drawing.type}`
    );
    return (
      <div className="p-4 text-sm text-muted-foreground">
        Configuration is not available for this drawing type yet.
      </div>
    );
  }

  return (
    <DrawingConfigScreen drawing={drawing} onBack={onBack} onSave={onSave} />
  );
}
